import BigNumber from "bignumber.js";
import contracts from "./contracts";
import { FarmPool, QuoteToken } from "./types";

export const BLOCKS_PER_YEAR = new BigNumber(10512000);

const CONTRACTS = {
  pancakeswapRouterAddress: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
  apeswapRouterAddress: "0xcF0feBd3f17CEf5b47b0cD257aCf6025c5BFf3b7",
  waultswapRouterAddress: "0xd48745e39bbed146eec15b79cbf964884f9877c2",
  cafeswapRouterAddress: "0x933DAea3a5995Fb94b14A7696a5F3ffD7B1E385A",
  jetswapRouterAddress: "0xBe65b8f75B9F20f4C522e0067a3887FADa714800",
  babyswapRouterAddress: "0x325E343f1dE602396E256B67eFd1F61C3A6B38Bd",
  dinosaurRouterAddress: "0xe9c7650b97712c0ec958ff270fbf4189fb99c071",
};

const pools: FarmPool[] = [
  // Pools
  // {
  //   apiIndexApy: "lory-golden-lory",
  //   apiIndexPrice: "LORY",
  //   contractAddress: {
  //     56: "0x4C913641DD53A3369DAcd15296aFa004570E4850",
  //     97: "",
  //   },
  //   earningToken: {
  //     address: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
  //     decimals: 18,
  //     name: QuoteToken.WBNB,
  //     pathToBnb: ["BNB"],
  //     token: QuoteToken.WBNB,
  //   },
  //   farm: {
  //     isCompounding: false,
  //     pid: 0,
  //   },
  //   id: "GOLDEN LORY",
  //   multiplier: 50,
  //   name: "GOLDEN LORY",
  //   network: "bsc",
  //   stakingToken: {
  //     address: "0xcD5D75Dbe75449A9021B6C570a41959eB571C751",
  //     buyLink:
  //       "https://exchange.babyswap.finance/#/add/0x55d398326f99059fF775485246999027B3197955/0xcd5d75dbe75449a9021b6c570a41959eb571c751",
  //     decimals: 18,
  //     name: QuoteToken.LORY,
  //     pathToBnb: ["BNB"],
  //     router: CONTRACTS.apeswapRouterAddress,
  //     token: QuoteToken.LORY,
  //     uses: "BabySwap",
  //   },
  //   strategyContractAddress: {
  //     56: "0x4C913641DD53A3369DAcd15296aFa004570E4850",
  //     97: "",
  //   },
  // },

  // Farms
  {
    apiIndexApy: "",
    apiIndexPrice: "BIKINI",
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: "BIKINI",
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 0,
    },
    id: "BIKINI",
    multiplier: 50,
    name: "BIKINI",
    network: "bsc",
    originFarm: {
      address: "",
      functionName: "",
      pid: 0,
    },
    stakingToken: {
      address: contracts.bikini[56],
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
      buyLink:
        "https://app.apeswap.finance/swap?outputCurrency=0xC865a1dFB8717F53261a935D5C2577fDA7523C55",
    },
    strategyContractAddress: {
      97: "",
      56: "0x88e438d54692bBBF275CbD2F0953B654Af7c0969",
    },
  },
  {
    apiIndexApy: "",
    apiIndexPrice: "bikini-bikini-bnb",
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: "BIKINI",
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: "BIKINI",
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 1,
    },
    id: "BIKINI-BNB LP",
    multiplier: 50,
    name: "BIKINI-BNB LP",
    network: "bsc",
    originFarm: {
      address: "",
      functionName: "",
      pid: 1,
    },
    stakingToken: {
      address: contracts.bikiniBnbLp[56],
      name: "BIKINI-BNB LP",
      pathToBnb: ["BIKINI", "BNB"],
      token: "BIKINI-BNB LP",
      uses: "ApeSwap",
      buyLink:
        "https://app.apeswap.finance/add/0xC865a1dFB8717F53261a935D5C2577fDA7523C55/ETH",
    },
    strategyContractAddress: {
      97: "",
      56: "0xbAB253664F1bDDDCBdef7b42F085374832c6e457",
    },
  },
  {
    apiIndexApy: "",
    apiIndexPrice: "bikini-bikini-busd",
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 2,
    },
    id: "BIKINI-BUSD LP",
    multiplier: 50,
    name: "BIKINI-BUSD LP",
    network: "bsc",
    originFarm: {
      address: "",
      functionName: "",
      pid: 2,
    },
    stakingToken: {
      address: contracts.bikiniBusdLp[56],
      name: QuoteToken.BIKINIBUSD,
      pathToBnb: ["BIKINI", "BNB"],
      token: QuoteToken.BIKINIBUSD,
      uses: "ApeSwap",
      buyLink:
        "https://app.apeswap.finance/add/0xC865a1dFB8717F53261a935D5C2577fDA7523C55/0xe9e7cea3dedca5984780bafc599bd69add087d56",
    },
    strategyContractAddress: {
      97: "",
      56: "0x0DadC530BFA2f81f92b5daB29A1f84510EC87F8A",
    },
  },
  {
    apiIndexApy: "",
    apiIndexPrice: "BUSD",
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 3,
    },
    id: "BUSD",
    multiplier: 50,
    name: "BUSD",
    network: "bsc",
    originFarm: {
      address: "",
      functionName: "",
      pid: 2,
    },
    stakingToken: {
      address: contracts.busd[56],
      name: QuoteToken.BUSD,
      pathToBnb: ["BUSD", "BNB"],
      token: QuoteToken.BUSD,
      uses: "PancakeSwap",
      buyLink:
        "https://pancakeswap.finance/swap?outputCurrency=0xe9e7cea3dedca5984780bafc599bd69add087d56",
    },
    strategyContractAddress: {
      97: "",
      56: "0xcb84BDD5DdE2C5F1421434C183942452Fc01f882",
    },
  },
  {
    apiIndexApy: "",
    apiIndexPrice: "USDC",
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 4,
    },
    id: "USDC",
    multiplier: 50,
    name: "USDC",
    network: "bsc",
    originFarm: {
      address: "",
      functionName: "",
      pid: 4,
    },
    stakingToken: {
      address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
      name: "USDC",
      pathToBnb: ["USDC", "BNB"],
      token: "USDC",
      uses: "PancakeSwap",
      buyLink:
        "https://pancakeswap.finance/swap?outputCurrency=0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    },
    strategyContractAddress: {
      97: "",
      56: "0x326c8183589e3aa33Dc366122ca7532F90c8BB09",
    },
  },
  {
    apiIndexApy: "",
    apiIndexPrice: "ADA",
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 5,
    },
    id: "ADA",
    multiplier: 50,
    name: "ADA",
    network: "bsc",
    originFarm: {
      address: "",
      functionName: "",
      pid: 5,
      earnApiIndexPrice: "",
    },
    stakingToken: {
      address: "0x3ee2200efb3400fabb9aacf31297cbdd1d435d47",
      name: "ADA",
      pathToBnb: ["ADA", "BNB"],
      token: "ADA",
      uses: "PancakeSwap",
      buyLink:
        "https://pancakeswap.finance/swap?outputCurrency=0x3ee2200efb3400fabb9aacf31297cbdd1d435d47",
    },
    strategyContractAddress: {
      97: "",
      56: "0x7EA389772DCE9be7E6181772144C1266D092B10B",
    },
  },
  {
    apiIndexApy: "baby-baby",
    apiIndexPrice: "BABY",
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 6,
    },
    id: "BABY",
    multiplier: 50,
    name: "BABY",
    network: "bsc",
    originFarm: {
      address: "0xdfaa0e08e357db0153927c7eabb492d1f60ac730",
      functionName: "pendingCake",
      pid: 0,
      earnApiIndexPrice: "BABY",
    },
    stakingToken: {
      address: "0x53E562b9B7E5E94b81f10e96Ee70Ad06df3D2657",
      name: "BABY",
      pathToBnb: ["BABY", "BNB"],
      token: "BABY",
      uses: "BabySwap",
      buyLink:
        "https://exchange.babyswap.finance/#/swap?outputCurrency=0x53E562b9B7E5E94b81f10e96Ee70Ad06df3D2657",
    },
    strategyContractAddress: {
      97: "",
      56: "0x323195b11b64fb24445d8A292b8326DD0A27BC9e",
    },
  },
  {
    apiIndexApy: "cake-cakev2",
    apiIndexPrice: "CAKE",
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 7,
    },
    id: "CAKE",
    multiplier: 50,
    name: "CAKE",
    network: "bsc",
    originFarm: {
      address: "0x73feaa1eE314F8c655E354234017bE2193C9E24E",
      functionName: "pendingCake",
      pid: 0,
      earnApiIndexPrice: "CAKE",
    },
    stakingToken: {
      address: "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
      name: "CAKE",
      pathToBnb: ["CAKE", "BNB"],
      token: "CAKE",
      uses: "PancakeSwap",
      buyLink:
        "https://pancakeswap.finance/swap?outputCurrency=0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
    },
    strategyContractAddress: {
      97: "",
      56: "0x0FFe200f3eA60Aa6da2A8ab1F3b09E70E3765376",
    },
  },
  {
    apiIndexApy: "cakev2-cake-bnb",
    apiIndexPrice: "cakev2-cake-bnb",
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 8,
    },
    id: "CAKE-BNB LP",
    multiplier: 50,
    name: "CAKE-BNB LP",
    network: "bsc",
    originFarm: {
      address: "0x73feaa1eE314F8c655E354234017bE2193C9E24E",
      functionName: "pendingCake",
      pid: 251,
      earnApiIndexPrice: "CAKE",
    },
    stakingToken: {
      address: "0x0eD7e52944161450477ee417DE9Cd3a859b14fD0",
      name: "CAKE-BNB LP",
      pathToBnb: ["CAKE", "BNB"],
      token: "CAKE-BNB LP",
      uses: "PancakeSwap",
      buyLink:
        "https://pancakeswap.finance/add/0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82/BNB",
    },
    strategyContractAddress: {
      97: "",
      56: "0x51931E3DfC86E4ce9e9bf42E86F9Fab1A5Dc5a21",
    },
  },
  {
    apiIndexApy: "banana-banana",
    apiIndexPrice: "BANANA",
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 9,
    },
    id: "BANANA",
    multiplier: 50,
    name: "BANANA",
    network: "bsc",
    originFarm: {
      address: "0x5c8D727b265DBAfaba67E050f2f739cAeEB4A6F9",
      functionName: "pendingCake",
      pid: 0,
      earnApiIndexPrice: "BANANA",
    },
    stakingToken: {
      address: "0x603c7f932ED1fc6575303D8Fb018fDCBb0f39a95",
      name: "BANANA",
      pathToBnb: ["BANANA", "BNB"],
      token: "BANANA",
      uses: "ApeSwap",
      buyLink:
        "https://app.apeswap.finance/swap?outputCurrency=0x603c7f932ED1fc6575303D8Fb018fDCBb0f39a95",
    },
    strategyContractAddress: {
      97: "",
      56: "0x1C899A19AF5448911e9f0a05628271F59bfA3a9B",
    },
  },
  {
    apiIndexApy: "banana-banana-bnb",
    apiIndexPrice: "banana-banana-bnb",
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 10,
    },
    id: "BANANA-BNB LP",
    multiplier: 50,
    name: "BANANA-BNB LP",
    network: "bsc",
    originFarm: {
      address: "0x5c8D727b265DBAfaba67E050f2f739cAeEB4A6F9",
      functionName: "pendingCake",
      pid: 1,
      earnApiIndexPrice: "BANANA",
    },
    stakingToken: {
      address: "0xF65C1C0478eFDe3c19b49EcBE7ACc57BB6B1D713",
      name: "BANANA-BNB LP",
      pathToBnb: ["BANANA", "BNB"],
      token: "BANANA-BNB LP",
      uses: "ApeSwap",
      buyLink:
        "https://app.apeswap.finance/add/0x603c7f932ED1fc6575303D8Fb018fDCBb0f39a95/ETH",
    },
    strategyContractAddress: {
      97: "",
      56: "0x1a4700f6a0a64c85aB5c205830E38Df91241D5D9",
    },
  },
  // Vaults
  {
    apiIndexApy: "cake-cakev2",
    apiIndexPrice: "CAKE",
    isVault: true,
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 11,
    },
    id: "CAKE",
    multiplier: 50,
    name: "CAKE",
    network: "bsc",
    originFarm: {
      address: "0x73feaa1eE314F8c655E354234017bE2193C9E24E",
      functionName: "pendingCake",
      pid: 0,
      earnApiIndexPrice: "CAKE",
    },
    stakingToken: {
      address: "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
      name: "CAKE",
      pathToBnb: ["CAKE", "BNB"],
      token: "CAKE",
      uses: "PancakeSwap",
      buyLink:
        "https://pancakeswap.finance/swap?outputCurrency=0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
    },
    strategyContractAddress: {
      97: "",
      56: "0x7fb5FDFe11C59844EC9eC8870cfbb574e439dac3",
    },
  },
  {
    apiIndexApy: "cakev2-cake-bnb",
    apiIndexPrice: "cakev2-cake-bnb",
    isVault: true,
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 12,
    },
    id: "CAKE-BNB LP",
    multiplier: 50,
    name: "CAKE-BNB LP",
    network: "bsc",
    originFarm: {
      address: "0x73feaa1eE314F8c655E354234017bE2193C9E24E",
      functionName: "pendingCake",
      pid: 251,
      earnApiIndexPrice: "CAKE",
    },
    stakingToken: {
      address: "0x0eD7e52944161450477ee417DE9Cd3a859b14fD0",
      name: "CAKE-BNB LP",
      pathToBnb: ["CAKE", "BNB"],
      token: "CAKE-BNB LP",
      uses: "PancakeSwap",
      buyLink:
        "https://pancakeswap.finance/add/0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82/BNB",
    },
    strategyContractAddress: {
      97: "",
      56: "0xd58c9535E050243D975A07bb2BeE35D7728D0C39",
    },
  },
  {
    apiIndexApy: "cakev2-btcb-bnb",
    apiIndexPrice: "cakev2-btcb-bnb",
    isVault: true,
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 13,
    },
    id: "BTCB-BNB LP",
    multiplier: 50,
    name: "BTCB-BNB LP",
    network: "bsc",
    originFarm: {
      address: "0x73feaa1eE314F8c655E354234017bE2193C9E24E",
      functionName: "pendingCake",
      pid: 262,
      earnApiIndexPrice: "CAKE",
    },
    stakingToken: {
      address: "0x61EB789d75A95CAa3fF50ed7E47b96c132fEc082",
      name: "BTCB-BNB LP",
      pathToBnb: ["BTCB", "BNB"],
      token: "BTCB-BNB LP",
      uses: "PancakeSwap",
      buyLink:
        "https://pancakeswap.finance/add/0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c/BNB",
    },
    strategyContractAddress: {
      97: "",
      56: "0x7f5A965b4992862462eC1c91E58E34f813692d38",
    },
  },
  {
    apiIndexApy: "banana-banana",
    apiIndexPrice: "BANANA",
    isVault: true,
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 14,
    },
    id: "BANANA",
    multiplier: 50,
    name: "BANANA",
    network: "bsc",
    originFarm: {
      address: "0x5c8D727b265DBAfaba67E050f2f739cAeEB4A6F9",
      functionName: "pendingCake",
      pid: 0,
      earnApiIndexPrice: "BANANA",
    },
    stakingToken: {
      address: "0x603c7f932ED1fc6575303D8Fb018fDCBb0f39a95",
      name: "BANANA",
      pathToBnb: ["BANANA", "BNB"],
      token: "BANANA",
      uses: "ApeSwap",
      buyLink:
        "https://app.apeswap.finance/swap?outputCurrency=0x603c7f932ED1fc6575303D8Fb018fDCBb0f39a95",
    },
    strategyContractAddress: {
      97: "",
      56: "0x2453cBd024f8144765b04482783dd059d4e15534",
    },
  },
  {
    apiIndexApy: "banana-banana-bnb",
    apiIndexPrice: "banana-banana-bnb",
    isVault: true,
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 15,
    },
    id: "BANANA-BNB LP",
    multiplier: 50,
    name: "BANANA-BNB LP",
    network: "bsc",
    originFarm: {
      address: "0x5c8D727b265DBAfaba67E050f2f739cAeEB4A6F9",
      functionName: "pendingCake",
      pid: 1,
      earnApiIndexPrice: "BANANA",
    },
    stakingToken: {
      address: "0xF65C1C0478eFDe3c19b49EcBE7ACc57BB6B1D713",
      name: "BANANA-BNB LP",
      pathToBnb: ["BANANA", "BNB"],
      token: "BANANA-BNB LP",
      uses: "ApeSwap",
      buyLink:
        "https://app.apeswap.finance/add/0x603c7f932ED1fc6575303D8Fb018fDCBb0f39a95/ETH",
    },
    strategyContractAddress: {
      97: "",
      56: "0xBdaE88c05DF2059f5A5D639951354A8f775b4ce8",
    },
  },
  {
    apiIndexApy: "banana-ada-bnb",
    apiIndexPrice: "banana-ada-bnb",
    isVault: true,
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 16,
    },
    id: "BUSD-BNB LP",
    multiplier: 50,
    name: "BUSD-BNB LP",
    network: "bsc",
    originFarm: {
      address: "0x5c8D727b265DBAfaba67E050f2f739cAeEB4A6F9",
      functionName: "pendingCake",
      pid: 3,
      earnApiIndexPrice: "BANANA",
    },
    stakingToken: {
      address: "0x51e6D27FA57373d8d4C256231241053a70Cb1d93",
      name: "BUSD-BNB LP",
      pathToBnb: ["BUSD", "BNB"],
      token: "BUSD-BNB LP",
      uses: "ApeSwap",
      buyLink:
        "https://app.apeswap.finance/add/0xe9e7cea3dedca5984780bafc599bd69add087d56/ETH",
    },
    strategyContractAddress: {
      97: "",
      56: "0xeBc8fD179280cc7B623007490B354Af4aCf65a9D",
    },
  },
  {
    apiIndexApy: "banana-ada-bnb",
    apiIndexPrice: "banana-ada-bnb",
    isVault: true,
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 17,
    },
    id: "ADA-BNB LP",
    multiplier: 50,
    name: "ADA-BNB LP",
    network: "bsc",
    originFarm: {
      address: "0x5c8D727b265DBAfaba67E050f2f739cAeEB4A6F9",
      functionName: "pendingCake",
      pid: 17,
      earnApiIndexPrice: "BANANA",
    },
    stakingToken: {
      address: "0x40d4543887E4170A1A40Cd8dB15A6b297c812Cb1",
      name: "ADA-BNB LP",
      pathToBnb: ["ADA", "BNB"],
      token: "ADA-BNB LP",
      uses: "ApeSwap",
      buyLink:
        "https://app.apeswap.finance/add/0x3ee2200efb3400fabb9aacf31297cbdd1d435d47/ETH",
    },
    strategyContractAddress: {
      97: "",
      56: "0x43bEE8B0a9fd123aa731d10C9A26d57BC8E86e73",
    },
  },
  {
    apiIndexApy: "baby-baby",
    apiIndexPrice: "BABY",
    isVault: true,
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 18,
    },
    id: "BABY",
    multiplier: 50,
    name: "BABY",
    network: "bsc",
    originFarm: {
      address: "0xdfaa0e08e357db0153927c7eabb492d1f60ac730",
      functionName: "pendingCake",
      pid: 0,
      earnApiIndexPrice: "BABY",
    },
    stakingToken: {
      address: "0x53E562b9B7E5E94b81f10e96Ee70Ad06df3D2657",
      name: "BABY",
      pathToBnb: ["BABY", "BNB"],
      token: "BABY",
      uses: "BabySwap",
      buyLink:
        "https://exchange.babyswap.finance/#/swap?outputCurrency=0x53E562b9B7E5E94b81f10e96Ee70Ad06df3D2657",
    },
    strategyContractAddress: {
      97: "",
      56: "0xA2CbDfa18Fa6E31A9D66E6D977BADcAf6f9e2C70",
    },
  },
  {
    apiIndexApy: "baby-baby-bnb",
    apiIndexPrice: "baby-baby-bnb",
    isVault: true,
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 19,
    },
    id: "BABY-BNB LP",
    multiplier: 50,
    name: "BABY-BNB LP",
    network: "bsc",
    originFarm: {
      address: "0xdfaa0e08e357db0153927c7eabb492d1f60ac730",
      functionName: "pendingCake",
      pid: 47,
      earnApiIndexPrice: "BABY",
    },
    stakingToken: {
      address: "0x36ae10a4d16311959b607ee98bc4a8a653a33b1f",
      name: "BABY-BNB LP",
      pathToBnb: ["BABY", "BNB"],
      token: "BABY-BNB LP",
      uses: "BabySwap",
      buyLink:
        "https://exchange.babyswap.finance/#/add/0x53E562b9B7E5E94b81f10e96Ee70Ad06df3D2657/BNB",
    },
    strategyContractAddress: {
      97: "",
      56: "0xd2914bfC18fBE6b9B72f38D7425F56023E3E3909",
    },
  },
  {
    apiIndexApy: "baby-bnb-usdt",
    apiIndexPrice: "baby-bnb-usdt",
    isVault: true,
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 20,
    },
    id: "BNB-USDT LP",
    multiplier: 50,
    name: "BNB-USDT LP",
    network: "bsc",
    originFarm: {
      address: "0xdfaa0e08e357db0153927c7eabb492d1f60ac730",
      functionName: "pendingCake",
      pid: 2,
      earnApiIndexPrice: "BABY",
    },
    stakingToken: {
      address: "0x04580ce6dee076354e96fed53cb839de9efb5f3f",
      name: "BNB-USDT LP",
      pathToBnb: ["BABY", "BNB"],
      token: "BNB-USDT LP",
      uses: "BabySwap",
      buyLink:
        "https://exchange.babyswap.finance/#/add/0x55d398326f99059ff775485246999027b3197955/BNB",
    },
    strategyContractAddress: {
      97: "",
      56: "0x4103Dd8F4a0321126519D7dF5a44Ac3814473D8E",
    },
  },
  {
    apiIndexApy: "baby-dai-usdt",
    apiIndexPrice: "baby-dai-usdt",
    isVault: true,
    contractAddress: {
      97: "",
      56: contracts.masterChef[56],
    },
    earningToken: {
      address: contracts.bikini[56],
      decimals: 18,
      name: QuoteToken.BIKINI,
      pathToBnb: ["BIKINI", "BNB"],
      router: CONTRACTS.apeswapRouterAddress,
      token: QuoteToken.BIKINI,
      uses: "ApeSwap",
    },
    farm: {
      functionName: "pendingNATIVE",
      isCompounding: true,
      pid: 21,
    },
    id: "DAI-USDT LP",
    multiplier: 50,
    name: "DAI-USDT LP",
    network: "bsc",
    originFarm: {
      address: "0xdfaa0e08e357db0153927c7eabb492d1f60ac730",
      functionName: "pendingCake",
      pid: 14,
      earnApiIndexPrice: "BABY",
    },
    stakingToken: {
      address: "0xf739d76fb14f39a5efe6622215384e8d2bd86e23",
      name: "DAI-USDT LP",
      pathToBnb: ["BABY", "BNB"],
      token: "DAI-USDT LP",
      uses: "BabySwap",
      buyLink:
        "https://exchange.babyswap.finance/#/add/0x55d398326f99059ff775485246999027b3197955/0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
    },
    strategyContractAddress: {
      97: "",
      56: "0xD5F833e738085e433aA5303c68C24Cfe9b6f4182",
    },
  },
];

export default pools;
